// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Video_videoWrapper__WgIcB","scale":"Video_scale___iV1r"};